<ng-container *ngIf="objectLoaded">

    <!--
      The call data widget belongs to state 'list' ONLY. While a protocol is being written the advisor
      needs the height, not the call header — so the upper widget yields the space to the protocol
      editor and returns on the way back.

      It does NOT have to be rebuilt for that, and deliberately is not: mvs-widget constructs its data
      provider from scratch in ngOnInit (mvs-widget.component.ts:370 -> refreshComponent(true) ->
      CoreDpService.getDataProvider, which caches nothing and hands out a NEW instance per call) and
      releases it again in ngOnDestroy. WidgetData itself is pure configuration and is never consumed
      by that cycle, so this @if may unmount and remount the widget as often as it likes and the data
      reloads each time. The rebuild in buildProtocolWorklist() exists for the LIST — whose toolbar
      buttons and import context must travel with a fresh WidgetData — and has no counterpart here.
    -->
    @if (widgetObject && protocolAreaState === 'list') {
        <mvs-widget [widgetData]="widgetObject"></mvs-widget>
    }

    <!--
      ONE area, TWO states. The list and the protocol never appear together — the protocol component
      REPLACES the list here, it does not open below it.

      Round-based LLM dialog — design: projects/pc_call_obc/REQUIREMENT.md §8.3.
    -->
    @if (protocolAreaState === 'list') {

        <!--
          disableUpdate suppresses the generic add/change/show menu entries of the list widget: they
          open a dialog and would be a second, contradicting way into protocol creation. The plus
          button in the toolbar is the only entry, and it opens state 'edit'.
        -->
        <mvs-widget
                *ngIf="widgetCallProtocols"
                [widgetData]="widgetCallProtocols"
                [importObjectContext]="callObjectContext"
                [widgetToolbarButtons]="protocolListButtons"
                [disableUpdate]="true"
                (onToolbarButtonClick)="onProtocolListToolbarButtonClick($event)"
                (onObjectSelect)="onProtocolSelect($event)"
        ></mvs-widget>

    } @else {

        <!--
          objectId is null in the create case. The protocol component receives the call reference in
          defaultCreateDto — the native channel of <mvs-object> (object.component.ts:136-150 assigns
          it to the component's dto before ngOnInit) — and writes the row immediately, so everything
          after that first POST is an edit.

          onBackNavigation is the component's report that the advisor wants to leave; the navigation
          decision stays here, in the host.
        -->
        <mvs-object
                objectType="pc.CallProtocol"
                [objectId]="editProtocolId"
                [defaultCreateDto]="protocolDefaultCreateDto"
                [importObjectContext]="callObjectContext"
                (onBackNavigation)="onProtocolBack()"
        ></mvs-object>

    }

</ng-container>
